// extracted by mini-css-extract-plugin
export default {"container":"MultiStateSwitch_container__EBOV7","inactive":"MultiStateSwitch_inactive__7U7Kc"};